import type { GQL_ID } from '@@partner:types:graphql'
import type { BannerType } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_PAGE_INFO_FIELDS,
  SHORTCUT_BANNER_TYPE_FIELDS
} from '@@partner:graphql/shortcuts'

export interface SingleBannerTypeQuery {
  bannerType: BannerType
}

export interface SingleBannerTypeQueryVariables {
  id?: GQL_ID
  label?: string
  code?: string
}

export const GQL_QUERY_SINGLE_BANNER_TYPE = gql`
  query ($id: ID!) {
    bannerType: singleBannerType(id: $id) {
      ${SHORTCUT_BANNER_TYPE_FIELDS}
  }
}
`

export const useFetchSingleBannerType = (
  variables: SingleBannerTypeQueryVariables
) =>
  useQuery<SingleBannerTypeQuery, SingleBannerTypeQueryVariables>(
    GQL_QUERY_SINGLE_BANNER_TYPE,
    {
      variables,
      skip: !variables.id,
      fetchPolicy: 'cache-and-network'
    }
  )
